"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Field = _interopRequireDefault(require("../field/Field"));

var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));

var _generateUniqueId = require("../../utils/generateUniqueId");

require("./CheckboxField.css");

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxField = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CheckboxField, _Component);

  var _super = _createSuper(CheckboxField);

  function CheckboxField(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxField);
    _this = _super.call(this, props);
    _this.forId = "stxField".concat((0, _generateUniqueId.generateUniqueId)());
    _this.messageId = "stxFieldMessage".concat((0, _generateUniqueId.generateUniqueId)());
    return _this;
  }

  (0, _createClass2["default"])(CheckboxField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          helpText = _this$props.helpText,
          messageType = _this$props.messageType,
          messageText = _this$props.messageText,
          messageId = _this$props.messageId,
          label = _this$props.label,
          remainingProps = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "className", "helpText", "messageType", "messageText", "messageId", "label"]);
      var classNames = (0, _classnames["default"])(['stx-checkbox-field__field', className]);
      var hasValidationError = messageType === 'alert' || messageType === 'error';
      return /*#__PURE__*/_react["default"].createElement(_Field["default"], {
        className: classNames,
        helpText: helpText,
        messageType: messageType,
        messageText: messageText,
        messageId: this.messageId
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "stx-checkbox-field__div"
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({
        id: id || this.forId,
        className: "stx-checkbox-field__checkbox",
        "aria-invalid": hasValidationError ? 'true' : undefined,
        "aria-describedby": messageId || this.messageId
      }, remainingProps)), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id || this.forId,
        className: "stx-checkbox-field__label"
      }, label)));
    }
  }]);
  return CheckboxField;
}(_react.Component);

CheckboxField.propTypes = {
  /** HTML ID attribute for the checkbox element */
  id: _propTypes["default"].string,

  /** Optional className for the field component */
  className: _propTypes["default"].string,

  /** The name or title of the form control */
  label: _propTypes["default"].node,

  /** Helpful text that describes how to use the form control */
  helpText: _propTypes["default"].node,

  /** The text for the message to display */
  messageText: _propTypes["default"].string,

  /** The type of message to display */
  messageType: _propTypes["default"].oneOf(['alert', 'warning', 'success', '']),

  /** The ID of the associated message element (automatically generated if not provided) */
  messageId: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].undefined]),

  /** Whether or not the checkbox is disabled */
  disabled: _propTypes["default"].bool
};
var _default = CheckboxField;
exports["default"] = _default;